<template>
    <div class="other">
    <p class="has-text-left has-text-weight-light title ">OTHER</p>
        <div class="uo">
        <p class="has-text-left subtitle">みんな大好き魚べい</p>
        <figure class="has-ratio is-16by9   has-text-left ">
            <iframe class="is-16by9 " src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d99558.481600603!2d134.68372905010074!3d34.77525046381387!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb2e7af50ad321ad3!2z6a2a44G544GEIOOCpOOCquODs-OCv-OCpuODs-Wnq-i3r-W6lw!5e0!3m2!1sja!2sjp!4v1570970649507!5m2!1sja!2sjp" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
        </figure>
            <figure class="has-ratio is-16by9   has-text-left ">
                <iframe class="is-16by9" width="560" height="315" src="https://www.youtube.com/embed/0-PJt9nNNkc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </figure>
    </div>
    </div>
</template>

<script>
    export default {
        name: "OTHER"
    }
</script>

<style scoped>
.uo{
    padding-left: 20px;
}
.subtitle{
    margin-bottom: 0;
    padding-bottom: 0;
    font-size: 24px;
    font-feature-settings: "palt" 1;
}
</style>